export { default } from './BreakingDealsCarouselContainerMobile';
